import { Popover as AntPopover } from "antd";

const Popover = ({ title, content, children }) => {
  const titleStyled = (
    <div
      style={{
        fontWeight: "500",
        color: "black",
      }}
    >
      {title}
    </div>
  );

  const contentStyled = (
    <div
      style={{
        fontWeight: "500",
        color: "grey",
      }}
    >
      {content}
    </div>
  );

  return (
    <AntPopover title={titleStyled} content={contentStyled} trigger="click">
      {children}
    </AntPopover>
  );
};

export default Popover;
